import { C, SectionLabel, H2, wrap, useIsMobile } from '../styles';

const points = [
  { t: 'No fee to get a quote', b: 'Submitting your project and receiving your quote costs nothing.' },
  { t: 'Accurate on agreed specs', b: 'We price against the specs we confirm together — what you see is what you pay, with no markups added on top.' },
  { t: 'No obligation', b: 'Review your quote and decide. There is no commitment to move forward.' },
];

export default function Pricing() {
  const isMobile = useIsMobile();
  return (
    <section id="pricing" style={{ padding: isMobile ? '64px 0' : '88px 0', borderTop: `1px solid ${C.bdr}` }}>
      <div style={wrap}>
        <SectionLabel orange>Pricing</SectionLabel>
        <H2 style={{ marginBottom: 12 }}>No fee to get a quote.</H2>
        <p style={{ color: C.mut, fontSize: 16, lineHeight: 1.7, maxWidth: 520, marginBottom: 44 }}>
          Tell us what you need and we'll confirm the specs with you. The quote you get back is accurate to those specs — no markups, no surprises, and no fee to find out what your project costs.
        </p>
        <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr 1fr', gap: 14 }}>
          {points.map((p) => (
            <div key={p.t} style={{
              background: C.surf, border: `1px solid ${C.bdr}`, borderRadius: 10, padding: 28,
              transition: 'border-color 0.2s',
            }}
              onMouseEnter={e => e.currentTarget.style.borderColor = C.orange}
              onMouseLeave={e => e.currentTarget.style.borderColor = C.bdr}
            >
              <div style={{ width: 24, height: 2, background: C.orange, marginBottom: 14 }} />
              <h3 style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: 21, fontWeight: 700, textTransform: 'uppercase', color: C.txt, marginBottom: 8 }}>{p.t}</h3>
              <p style={{ fontSize: 13, color: C.mut, lineHeight: 1.7 }}>{p.b}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
